// extracted by mini-css-extract-plugin
export var legendIndicator = "_9z-1";
export var legendRight = "_9z-0";